exports.read = function (p5919, p5920, p5921, p5922, p5923) {
  var v4932;
  var v4933;
  var v4934 = p5923 * 8 - p5922 - 1;
  var v4935 = (1 << v4934) - 1;
  var v4936 = v4935 >> 1;
  var v4937 = -7;
  var v4938 = p5921 ? p5923 - 1 : 0;
  var v4939 = p5921 ? -1 : 1;
  var v4940 = p5919[p5920 + v4938];
  v4938 += v4939;
  v4932 = v4940 & (1 << -v4937) - 1;
  v4940 >>= -v4937;
  v4937 += v4934;
  for (; v4937 > 0; v4932 = v4932 * 256 + p5919[p5920 + v4938], v4938 += v4939, v4937 -= 8) {
    ;
  }
  v4933 = v4932 & (1 << -v4937) - 1;
  v4932 >>= -v4937;
  v4937 += p5922;
  for (; v4937 > 0; v4933 = v4933 * 256 + p5919[p5920 + v4938], v4938 += v4939, v4937 -= 8) {
    ;
  }
  if (v4932 === 0) {
    v4932 = 1 - v4936;
  } else {
    if (v4932 === v4935) {
      if (v4933) {
        return NaN;
      } else {
        return (v4940 ? -1 : 1) * Infinity;
      }
    }
    v4933 += Math.pow(2, p5922);
    v4932 -= v4936;
  }
  return (v4940 ? -1 : 1) * v4933 * Math.pow(2, v4932 - p5922);
};
exports.write = function (p5924, p5925, p5926, p5927, p5928, p5929) {
  var v4941;
  var v4942;
  var v4943;
  var v4944 = p5929 * 8 - p5928 - 1;
  var v4945 = (1 << v4944) - 1;
  var v4946 = v4945 >> 1;
  var v4947 = p5928 === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var v4948 = p5927 ? 0 : p5929 - 1;
  var v4949 = p5927 ? 1 : -1;
  var v4950 = p5925 < 0 || p5925 === 0 && 1 / p5925 < 0 ? 1 : 0;
  p5925 = Math.abs(p5925);
  if (isNaN(p5925) || p5925 === Infinity) {
    v4942 = isNaN(p5925) ? 1 : 0;
    v4941 = v4945;
  } else {
    v4941 = Math.floor(Math.log(p5925) / Math.LN2);
    if (p5925 * (v4943 = Math.pow(2, -v4941)) < 1) {
      v4941--;
      v4943 *= 2;
    }
    p5925 += v4941 + v4946 >= 1 ? v4947 / v4943 : v4947 * Math.pow(2, 1 - v4946);
    if (p5925 * v4943 >= 2) {
      v4941++;
      v4943 /= 2;
    }
    if (v4941 + v4946 >= v4945) {
      v4942 = 0;
      v4941 = v4945;
    } else if (v4941 + v4946 >= 1) {
      v4942 = (p5925 * v4943 - 1) * Math.pow(2, p5928);
      v4941 += v4946;
    } else {
      v4942 = p5925 * Math.pow(2, v4946 - 1) * Math.pow(2, p5928);
      v4941 = 0;
    }
  }
  for (; p5928 >= 8; p5924[p5926 + v4948] = v4942 & 255, v4948 += v4949, v4942 /= 256, p5928 -= 8) {
    ;
  }
  v4941 = v4941 << p5928 | v4942;
  v4944 += p5928;
  for (; v4944 > 0; p5924[p5926 + v4948] = v4941 & 255, v4948 += v4949, v4941 /= 256, v4944 -= 8) {
    ;
  }
  p5924[p5926 + v4948 - v4949] |= v4950 * 128;
};